// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../layout-and-structure/Box.res.js";
import * as Badge from "../feedback-indicators/Badge.res.js";
import * as Field from "../layout-and-structure/Field.res.js";
import * as React from "react";
import * as Inline from "../layout-and-structure/Inline.res.js";
import * as TextStyle from "../typography/TextStyle.res.js";
import * as Touchable from "../../primitives/Touchable.res.js";
import * as ReactAria from "react-aria";
import * as ToggleSwitch from "./ToggleSwitch.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
let styles = {
  view: {
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "display-k1xSpc": "display-x78zum5",
    "paddingBottom-kGO01o": "paddingBottom-x18d9i69",
    $$css: "wino-gc:src/resources/selection-and-input/InputToggleSwitchField.res.js:17"
  }
};
function InputToggleSwitchField(props) {
  let onChange = props.onChange;
  let __labelSpaceRight = props.labelSpaceRight;
  let __size = props.size;
  let __disabled = props.disabled;
  let value = props.value;
  let __alignToggleButtonToStart = props.alignToggleButtonToStart;
  let badge = props.badge;
  let alignToggleButtonToStart = __alignToggleButtonToStart !== undefined ? __alignToggleButtonToStart : false;
  let disabled = __disabled !== undefined ? __disabled : false;
  let size = __size !== undefined ? __size : "normal";
  let labelSpaceRight = __labelSpaceRight !== undefined ? __labelSpaceRight : "normal";
  let match = ReactAria.useHover({
    isDisabled: disabled
  });
  let hovered = match.isHovered;
  let newrecord = {
    ...match.hoverProps
  };
  let newrecord$1 = {
    ...Stylex.props(styles.view, {
      justifyContent: alignToggleButtonToStart ? "flex-start" : "space-between"
    })
  };
  let tmp;
  if (badge !== undefined) {
    let newrecord$2 = {
      ...{
        className: "marginRight-x1wsuqlk",
        "data-style-src": "wino-gc:src/resources/selection-and-input/InputToggleSwitchField.res.js:27"
      }
    };
    tmp = JsxRuntime.jsx("div", (newrecord$2.children = JsxRuntime.jsx(Badge.make, {
      children: badge,
      variation: "information"
    }), newrecord$2));
  } else {
    tmp = null;
  }
  newrecord$1.children = [JsxRuntime.jsx(Box.make, {
    children: JsxRuntime.jsx(TextStyle.make, {
      children: Field.makeLabel(props.label, props.required),
      weight: props.labelWeight,
      size: props.labelSize,
      underlined: hovered,
      maxLines: props.labelMaxLines
    }),
    spaceRight: labelSpaceRight,
    style: Primitive_option.some(alignToggleButtonToStart ? {} : {
      flex: "1",
      minWidth: "0px"
    })
  }), JsxRuntime.jsxs(Inline.make, {
    children: [tmp, JsxRuntime.jsx(ToggleSwitch.make, {
      value: value,
      disabled: disabled,
      hovered: hovered,
      size: size
    })]
  })];
  newrecord.children = JsxRuntime.jsx(Touchable.make, {
    children: JsxRuntime.jsxs("div", newrecord$1),
    disabled: disabled,
    onPress: param => onChange(!value)
  });
  return JsxRuntime.jsx(Field.make, {
    children: JsxRuntime.jsx("div", newrecord),
    errorMessage: props.errorMessage
  });
}
let make = React.memo(InputToggleSwitchField);
export { make };
/* styles Not a pure module */